export const numberValidator = (value: string) => {
  if (isNaN(+value)) return "Input requires numbers only";
};
